export default {
  getEmailLog: (state) => state.emailLog,
};
